import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '../../lib/react-router';
import { rest } from '@/lib/hono-client';
import TodosPage from '@/features/todos/TodosPage';
import { queryClient } from '@/lib/react-query';
import { todosQueryOptions } from '@/features/todos/todos-hooks';

const todosRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/todos',

  beforeLoad: async () => {
    const whoami = await rest.api.auth.whoami.$get();
    if (!whoami.ok) {
      redirect({ to: '/login' });
      console.debug('Todos route not authenticated, redirecting to /login');
    }
    console.debug('Todos route is authenticated:', await whoami.json());
  },

  loader: async () => {
    await queryClient.ensureQueryData(todosQueryOptions);
    console.debug('Todos route loader data prefetched');
  },

  component: TodosPage,
});

export const todosRoutes = [todosRoute];
